import { styled } from "@mui/material/styles";

export const ModalContainer = styled("div")(({ theme }) => ({
  width: "640px",
  position: "absolute",
  top: "50%;",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 20px 24px -4px #0A0D12",
  color: "#211F45",
  maxHeight: "700px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  "&.wider": {
    width: "850px",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  "&.slim": {
    width: "400px",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  [theme.breakpoints.down("md")]: {
    width: "90%",
  },
  "& .modal-header": {
    display: "flex",
    alignItems: "center",
    borderBottom: "#E9EAEB 2px solid",
    padding: "32px",
    gap: "20px",
    "& h2": {
      fontSize: "18px",
      fontWeight: "600",
      margin: "0",
      maxWidth: "80%",
      lineHeight: "1.3",
      "& span": {
        display: "block",
        fontWeight: "normal",
        fontSize: "14px",
        color: "#666",
      },
    },
    "& .modal-icon": {
      border: "#E9EAEB 1px solid",
      padding: "12px",
      borderRadius: "12px",
      display: "flex",
    },
  },
  "& .modal-inner": {
    padding: "20px 32px",
    overflowY: "auto",
    flex: 1,
    minHeight: 0,
    "& > p": {
      margin: "0 0 15px 0",
      fontSize: "14px",
      color: "#535862",
    },
  },
  "& .close-icon": {
    position: "absolute",
    border: 0,
    background: "transparent",
    right: "32px",
    top: "32px",
    cursor: "pointer",
    "& svg": {
      width: 30,
      height: 30,
    },
  },
  "& .button-group": {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  "& .action-button": {
    width: "100%",
    padding: "12px 15px",
    "& p": {
      display: "flex",
      justifyContent: "center",
    },
  },
  "& .confirm-delete": {
    color: "#D92D20",
    fontFamily: "inherit",
    border: 0,
    background: "transparent",
    fontWeight: "600",
    cursor: "pointer",
  },
  "& .available-subjects": {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px",
    "& .speaker": {
      display: "flex",
      background: "transparent",
      border: "#ccc 2px solid",
      padding: "15px",
      borderRadius: "12px",
      alignItems: "center",
      gap: "5px",
      fontFamily: "inherit",
      cursor: "pointer",
      "&.active": {
        borderColor: "#962EFF",
        color: "#962EFF",
        fontWeight: "bold",
      },
    },
  },
  "& .cancel": {
    border: 0,
    background: "transparent",
    fontFamily: "inherit",
    margin: "15px auto 0 auto",
    display: "flex",
    cursor: "pointer",
    padding: "12px 0",
    fontWeight: "600",
    color: "#777",
  },
  "& .code-inputs": {
    display: "flex",
    gap: "8px",
    "& input": {
      flex: 1, // each cell grows equally to fill the row
      minWidth: 0, // prevents flex overflow
      height: "56px",
      textAlign: "center",
      fontSize: "22px",
      fontWeight: "600",
      color: "#211F45",
      borderRadius: "10px",
      border: "1.5px solid #E9EAEB",
      background: "#FAFAFA",
      transition: "border-color 0.15s, background 0.15s, box-shadow 0.15s",
      cursor: "text",
      "&::placeholder": {
        color: "#D0D5DD",
        fontWeight: "400",
      },
      "&:hover:not(:disabled)": {
        borderColor: "#C4B5FD",
        background: "#fff",
      },
      "&:focus": {
        border: "2px solid #962EFF !important",
        background: "#fff",
        outline: "none",
        boxShadow: "0 0 0 3px rgba(150, 46, 255, 0.12)",
      },
      "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
      },
    },
  },
}));
